<template>
  <div id="wcb" class="carbonbadge wcb-d"></div>
</template>

<script>
import addBadgeInPage from '../libs/webcarbon'

export default {
  data () { 
    return {

    }},
  mounted: () => {
    addBadgeInPage()
  }
}
</script>
